import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import clsx from 'clsx';
import { CheckIcon } from '../../icons/checkIcon';

const Checkbox = React.forwardRef(({ checkboxClassName, checkIconClassName, className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={clsx(
      'group h-5 w-5 rounded-sm border border-grenite focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-secondary data-[state=checked]:text-primary-foreground',
      className
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={clsx('flex items-center justify-center text-current')}
    >
      <div className={clsx("h-5 w-5 bg-black flex items-center justify-center", checkboxClassName)}>
        <CheckIcon className={clsx('stroke-white',checkIconClassName)}/>
      </div>
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
